import styles from "./create.module.css";
import { Button, Modal, Input, Form, message, Switch, Popover } from "antd";
import {
  AppstoreAddOutlined,
  QuestionCircleTwoTone,
  WarningOutlined,
} from "@ant-design/icons";
import { useContext, useState } from "react";
import { app, db } from "../utils/firebase";
import { MyContext } from "../utils/utils";
import { push, ref, update, set } from "firebase/database";
import { useNavigate } from "react-router-dom";

const Create = ({}) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const { currentUser, setCurrentUser } = useContext(MyContext);

  const showModal = () => {
    if (currentUser == null) {
      message.error({ content: "로그인해주세요", key: "updateable" });
    } else {
      setIsModalVisible(true);
    }
  };

  const [hardMode, setHardMode] = useState(false);

  const onChange = (checked) => {
    setHardMode(checked);
  };

  const handleOk = () => {
    if (currentUser == null) return;
    const name = document.getElementById("roomname").value;
    const password = document.getElementById("roompassword").value;
    setLoading(true);
    push(ref(db, "rooms"), {
      name: name,
      password: password,
      creator: currentUser.uid,
      state: "OPEN",
      mode: {
        card: true,
        distance: true,
        turn: true,
        hard: hardMode,
      },
    }).then((snap) => {
      const key = snap.key;
      const joinerRef = ref(db, "rooms/" + key + "/joiner/" + currentUser.uid);
      const userInfo = {
        name: currentUser.displayName,
      };
      update(joinerRef, userInfo);

      const userRef = ref(db, "users/" + currentUser.uid + "/" + key);
      set(userRef, "creator");

      const url = "/game/" + key;
      navigate(url);
    });
    setTimeout(() => {
      setLoading(false);
      setIsModalVisible(false);
    }, 1000);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setLoading(false);
  };

  const onFinish = (values: any) => {
    console.log("Success:", values);
  };

  const content = (
    <div className={styles.content}>
      <p>매운맛 모드란?</p>
      <p>
        색다르고 자극적인 질문을 하고 싶어하는 사람들의 아이디어를 받아
        <b>(개발자 아이디어는 아닙니다..)</b> 매운맛 카드를 추가했습니다. 전체
        카드에 보라색의 카드가 추가됩니다. 처음 알아가는 사람끼리는 안하는 것을
        추천합니다.{" "}
      </p>
    </div>
  );

  return (
    <div className={styles.panel}>
      <Button icon={<AppstoreAddOutlined />} size="large" onClick={showModal}>
        방 만들기
      </Button>

      <Modal
        title="방 만들기"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button
            type="primary"
            htmlType="submit"
            onClick={handleOk}
            loading={loading}
          >
            완료
          </Button>,
          <Button key="back" onClick={handleCancel}>
            취소
          </Button>,
        ]}
      >
        <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            label="방 이름"
            name="roomname"
            rules={[{ required: true, message: "방 이름을 입력해주세요!" }]}
          >
            <Input id="roomname" />
          </Form.Item>

          <Form.Item
            label="비밀번호"
            name="roompassword"
            rules={[{ required: true, message: "방 비밀번호를 입력해주세요!" }]}
          >
            <Input id="roompassword" />
          </Form.Item>

          <Form.Item
            label="매운맛 모드"
            valuePropName="checked"
            name="hardmode"
          >
            <Switch onChange={onChange} />
            <Popover content={content}>
              <Button
                icon={<QuestionCircleTwoTone />}
                type="link"
                size="large"
              ></Button>
            </Popover>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Create;
